import { lazyImgTheme, lazyImgTheme2 } from "@project/theme-lazyimg"

export const rolloverTheme = {
  activeImage: true,
  imageStyle:"object-fit: contain; width:100%; height:auto; margin-top:0px;",
  imageAriaLabel:"employee picure",
  outerClasses:"sb-v aboutus-rollover-area sb-explicit sb-gr sb-g10",
  outerCSS:"padding:0px;",
  coverType:"funky",
  coverCSS: `background-color:rgba(0,0,0,0.4)`, 
  coverRows:5,
  coverCols:5,
  onContentClasses: "sb-v sb-alt2 sb-align-c sb-g20",
  offContentClasses: "sb-v sb-align-2bottom sb-gr sb-g20 about-page-bios-offContent",
  lazyImgTheme,
}

// export const rolloverTheme2 = {
//   activeImage: true,
//   imageStyle:"object-fit: contain; width:100%; height:auto; margin-top:0px;",
//   imageAriaLabel:"employee picure",
//   outerClasses:"sb-v aboutus-rollover-area sb-explicit sb-gr sb-g10",
//   outerCSS:"padding:0px;",
//   coverType:"funky",
//   coverCSS: `background-color:rgba(0,0,255,0.4)`, 
//   coverRows:5,
//   coverCols:5,
//   onContentClasses: "sb-v sb-alt2 sb-align-c sb-g20",
//   offContentClasses: "sb-v sb-align-2bottom sb-gr sb-g20 about-page-bios-offContent",
//   lazyImgTheme2,
// }

export const servicesRolloverInfoArea = {
  outerClasses:"sb-explicit article-2-rollover-areas",
  coverType:"funky",
  coverCSS: "", 
  coverRows:5,
  coverCols:5,
  onContentClasses: "sb-v sb-alt2 sb-align-c sb-g20",
  offContentClasses: "sb-v sb-alt2 sb-align-c sb-g20",
  lazyImgTheme: {
    ...lazyImgTheme,
    background: true,
    style:"background-size:cover; background-repeat:no-repeat; background-position:center; width:100%; height:auto; padding: 30px;",
    loadingStyle:"background-size:contain; background-repeat:no-repeat; background-position:center; background-size:40%; width:100%; height:100%;"
  }
}